import React, { useState } from 'react';
import classnames from 'classnames';
import moment from 'moment';

import styles from './fundProfileAdminDashboardStyles';

import AboutIntroRequestsModal from './AboutIntroRequestsModal/aboutIntroRequestsModal';
import AllocatorBlocklistModal from 'buyside/components/presentation/FundProfileShowPage/AllocatorBlocklistModal/allocatorBlocklistModal';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import FundProfileAdmins from 'buyside/components/presentation/FundProfileShowPage/FundProfileAdminDashboard/FundProfileAdmins/fundProfileAdmins';
import PublishFundModal from './PublishFundModal/publishFundModal';

import BarChartIcon from 'buyside/svgs/bar_chart.svg';
import EyeIcon from 'SVGs/eye';
import PieChartIcon from 'buyside/svgs/pie_chart.svg';

import { employerProfileVanityUrl } from 'buyside/util/urlHelper';
import { formatDate } from 'buyside/util/dateHelper';
import { titleize } from 'inflection';

const FundProfileAdminDashboard = ({
  currentEmployees,
  currentUserId,
  fundAdminIds,
  fundProfileId,
  introRequestPeriodEnd,
  introRequestsLeft,
  isAdmin,
  publishProfile,
  status,
  toggleViewAsMode,
  updatedAt,
  vanityLink
}) => {
  const [isAllocatorBlocklistModalOpen, setIsAllocatorBlocklistModalOpen] = useState(false);

  const isPublished = status === 'active' || isAdmin;
  const daysSinceLastUpdate = moment().diff(moment(new Date(updatedAt)), 'days');
  let lastUpdatedStatus = 'active';
  if (daysSinceLastUpdate > 30) {
    lastUpdatedStatus = 'pending';
  }
  if (daysSinceLastUpdate > 180) {
    lastUpdatedStatus = 'alert';
  }
  return (
    <div className={styles.dashboard}>
      <h4 className={styles.dashboardTitle}>Admin Dashboard</h4>
      <div className={styles.dashboardSection}>
        <h5>Actions</h5>
        <div className={styles.dashboardActions}>
          <Button
            disabled={!isPublished}
            icon={BarChartIcon}
            text={`View detailed fund analytics ${isPublished ? '' : '— unavailable'}`}
            type={BUTTON_TYPES.LINK}
            url={isPublished && `${employerProfileVanityUrl(vanityLink)}/fund_analytics`}
          />
          <Button
            buttonType={BUTTON_TYPES.BUTTON}
            icon={EyeIcon}
            onClick={toggleViewAsMode}
            text="View your fund as another user"
            type={BUTTON_TYPES.LINK}
          />
          <AllocatorBlocklistModal
            buttonOptions={{
              icon: PieChartIcon,
              id: 'blocklist-modal-button',
              onClick: () => setIsAllocatorBlocklistModalOpen(true),
              text: 'Manage Allocator Blocklist',
              type: BUTTON_TYPES.LINK
            }}
            isOpen={isAllocatorBlocklistModalOpen}
            onClose={() => setIsAllocatorBlocklistModalOpen(false)}
            fundProfileId={fundProfileId}
          />
        </div>
      </div>
      {currentEmployees.length ? (
        <div className={styles.dashboardSection}>
          <FundProfileAdmins
            currentEmployees={currentEmployees}
            currentUserId={currentUserId}
            fundAdminIds={fundAdminIds}
            fundProfileId={fundProfileId}
          />
        </div>
      ) : null}
      {isPublished && (
        <div className={styles.dashboardSection}>
          <h5>Introduction Requests</h5>
          You have <strong>{introRequestsLeft}</strong>
          &nbsp;introduction request
          {introRequestsLeft === 1 ? '' : 's'}
          &nbsp;remaining until {formatDate(introRequestPeriodEnd)}
          .&nbsp;
          <AboutIntroRequestsModal />
        </div>
      )}
      <div className={styles.flexContainer}>
        <div>
          <span className={classnames(styles.dashboardProfileStatus, styles[status])}>
            Profile Status: {titleize(status)}
          </span>
        </div>
        <div>
          <span className={classnames(styles.dashboardProfileStatus, styles[lastUpdatedStatus])}>
            Last Updated: {formatDate(updatedAt)}
          </span>
        </div>
      </div>
      {status === 'draft' && (
        <div className={styles.publishFundButton}>
          <PublishFundModal publishProfile={publishProfile} />
        </div>
      )}
    </div>
  );
};

export default FundProfileAdminDashboard;
